module.exports = __webpack_public_path__ + "img/2-2.c94c99fe.jpg";